export default __webpack_public_path__ + "static/media/571.21a0e42c.png";